import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { FiHome, FiArrowLeft } from 'react-icons/fi';

export const NotFound: React.FC = () => {
  return (
    <>
      <SEO
        title="404 - Page Not Found | Your Casinos"
        description="The page you're looking for doesn't exist."
        canonical="/404"
      />

      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-center px-4">
          <h1 className="text-6xl md:text-8xl font-bold text-primary-green mb-4">404</h1>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Page Not Found
          </h2>
          <p className="text-gray-400 mb-8 max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved. 
            Let's get you back on track.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="btn-primary inline-flex items-center justify-center">
              <FiHome className="mr-2" />
              Go Home
            </Link>
            <button
              onClick={() => window.history.back()}
              className="btn-secondary inline-flex items-center justify-center"
            >
              <FiArrowLeft className="mr-2" />
              Go Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

